(() => {
  const money = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, format);
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount(?:_with_comma_separator|_no_decimals|_no_decimals_with_comma_separator)?\s*\}\}/, amount);
  };
  const sectionInner = (html, selector = '.shopify-section') => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  };
  const renderCartSections = state => {
    if (!state?.sections) return;
    [
      { id:'Cart', key:'main-cart', selector:'.thb-cart-form' },
      { id:'Cart-Drawer', key:'cart-drawer', selector:'.cart-drawer' },
      { id:'cart-drawer-toggle', key:'cart-bubble', selector:'.thb-item-count' }
    ].forEach(({id,key,selector}) => {
      const host=document.getElementById(id), html=state.sections[key];
      if(!host||!html)return;
      const target=host.querySelector(selector)||host, next=sectionInner(html,selector);
      if(next)target.innerHTML=next;
    });
    if(typeof CartDrawer!=='undefined') new CartDrawer();
    if(typeof Cart!=='undefined') new Cart().renderContents(state);
  };
  const openCartDrawer = () => {
    const drawer=document.getElementById('Cart-Drawer');
    if(!drawer)return;
    document.body.classList.add('open-cc','open-cart');
    drawer.classList.add('active');
    try{document.dispatchEvent(new CustomEvent('cart-drawer:open'));}catch(_){}
  };
  const init = root => {
    if(!root||root.dataset.wgVapeReady==='true')return;
    root.dataset.wgVapeReady='true';

    const variantsNode=root.querySelector('[data-wg-vape-variants]');
    let variants=[];try{variants=JSON.parse(variantsNode?.textContent||'[]');}catch(_){}
    const moneyFormat=root.dataset.moneyFormat||'${{amount}}';
    const form=root.querySelector('[data-wg-vape-product-form]');
    const variantInput=root.querySelector('[data-wg-vape-variant-id]');
    const priceEl=root.querySelector('[data-wg-vape-price]');
    const compareEl=root.querySelector('[data-wg-vape-compare-price]');
    const addButton=root.querySelector('[data-wg-vape-add]');
    const buyButton=root.querySelector('[data-wg-vape-buy]');

    const optionButtons=[...root.querySelectorAll('[data-wg-vape-option]')];
    const optionGroups=[...root.querySelectorAll('[data-wg-vape-option-group]')];
    const selectedOptions=[];
    optionButtons.filter(button=>button.classList.contains('is-active')).forEach(button=>{
      selectedOptions[Number(button.dataset.optionIndex)]=button.dataset.value;
    });
    if(optionButtons.length&&!selectedOptions.filter(Boolean).length){
      const initialVariant=variants.find(v=>String(v.id)===String(variantInput?.value))||variants.find(v=>v.available)||variants[0];
      if(Array.isArray(initialVariant?.options))initialVariant.options.forEach((value,index)=>{selectedOptions[index]=value;});
    }

    const currentVariant=()=>{
      if(optionButtons.length){
        return variants.find(v=>Array.isArray(v.options)&&v.options.length===selectedOptions.length&&v.options.every((value,index)=>value===selectedOptions[index]))||null;
      }
      return variants.find(v=>String(v.id)===String(variantInput?.value))||variants.find(v=>v.available)||variants[0]||null;
    };

    const updateOptionAvailability=()=>{
      if(!optionButtons.length)return;
      optionButtons.forEach(button=>{
        const index=Number(button.dataset.optionIndex);
        const available=variants.some(variant=>Array.isArray(variant.options)&&variant.available&&variant.options.every((value,optionIndex)=>{
          if(optionIndex===index)return value===button.dataset.value;
          return !selectedOptions[optionIndex]||value===selectedOptions[optionIndex];
        }));
        button.disabled=!available;
        button.classList.toggle('is-unavailable',!available);
        button.setAttribute('aria-disabled',String(!available));
      });
    };

    const updateVariant=()=>{
      const variant=currentVariant();
      const previousId=variantInput?.value;
      if(variantInput){
        variantInput.value=variant?.id||'';
        variantInput.disabled=!variant;
      }
      updateOptionAvailability();
      optionGroups.forEach(group=>{
        const index=Number(group.dataset.optionIndex);
        const label=group.querySelector('[data-wg-vape-option-label]');
        if(label)label.textContent=selectedOptions[index]||'';
      });
      if(!variant){
        [addButton,buyButton].forEach(btn=>{if(!btn)return;btn.disabled=true;btn.setAttribute('aria-disabled','true');});
        if(addButton){const text=addButton.querySelector('[data-wg-vape-button-text]');if(text)text.textContent='UNAVAILABLE';}
        return;
      }
      if(priceEl)priceEl.textContent=money(variant.price,moneyFormat);
      if(compareEl){const show=variant.compare_at_price&&variant.compare_at_price>variant.price;compareEl.hidden=!show;compareEl.textContent=show?money(variant.compare_at_price,moneyFormat):'';}
      [addButton,buyButton].forEach(btn=>{if(!btn)return;btn.disabled=!variant.available;btn.setAttribute('aria-disabled',String(!variant.available));});
      if(addButton){const text=addButton.querySelector('[data-wg-vape-button-text]');if(text)text.textContent=variant.available?(addButton.dataset.availableText||'ADD TO CART'):(addButton.dataset.soldText||'SOLD OUT');}
      const mediaId=variant.featured_media?.id||variant.featured_image?.id;
      if(mediaId)showMediaById(mediaId);
      try{
        const url=new URL(window.location.href);
        url.searchParams.set('variant',variant.id);
        window.history.replaceState({},'',url.toString());
      }catch(_){}
      if(variantInput&&String(previousId)!==String(variant.id)){
        variantInput.dispatchEvent(new Event('input',{bubbles:true}));
        variantInput.dispatchEvent(new Event('change',{bubbles:true}));
        root.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant}}));
      }
    };

    const removeInjectedCheckout=()=>{
      root.querySelectorAll('.shopify-payment-button,.additional-checkout-buttons,.payment_icons_wrap,.payment-icons-wrap,[class*="secure-checkout"],[class*="secure_checkout"],[data-testid*="secure-checkout"]').forEach(e=>e.remove());
      root.querySelectorAll('p,span,div').forEach(e=>{
        if(e.children.length>3)return;
        const t=(e.textContent||'').trim().replace(/\s+/g,' ');
        if(/^secure checkout with\b/i.test(t)){const p=e.parentElement;if(p&&(p.textContent||'').trim().replace(/\s+/g,' ')===t)p.remove();else e.remove();}
      });
    };
    removeInjectedCheckout();
    const observer=new MutationObserver(removeInjectedCheckout);
    observer.observe(root,{childList:true,subtree:true});
    setTimeout(()=>observer.disconnect(),10000);

    const slides=[...root.querySelectorAll('[data-wg-vape-media]')];
    const thumbs=[...root.querySelectorAll('[data-wg-vape-thumb]')];
    root.dataset.galleryIndex=String(Math.max(0,slides.findIndex(s=>s.classList.contains('is-active'))));
    const showAt=index=>{
      if(!slides.length)return;
      const i=(index+slides.length)%slides.length;
      slides.forEach((s,n)=>s.classList.toggle('is-active',n===i));
      thumbs.forEach((t,n)=>t.classList.toggle('is-active',n===i));
      root.dataset.galleryIndex=String(i);
    };
    const showMediaById=mediaId=>{
      const index=slides.findIndex(slide=>String(slide.dataset.mediaId)===String(mediaId));
      if(index>=0)showAt(index);
    };
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>showAt(i)));
    optionButtons.forEach(button=>button.addEventListener('click',()=>{
      if(button.disabled)return;
      const index=Number(button.dataset.optionIndex);
      selectedOptions[index]=button.dataset.value;
      optionButtons.filter(item=>Number(item.dataset.optionIndex)===index).forEach(item=>{
        const active=item===button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',String(active));
      });
      updateVariant();
    }));
    root.querySelector('[data-wg-vape-gallery-prev]')?.addEventListener('click',()=>showAt(Number(root.dataset.galleryIndex||0)-1));
    root.querySelector('[data-wg-vape-gallery-next]')?.addEventListener('click',()=>showAt(Number(root.dataset.galleryIndex||0)+1));

    const qtyInput=root.querySelector('[data-wg-vape-qty]');
    const qtyDisplay=root.querySelector('[data-wg-vape-qty-display]');
    const setQty=value=>{
      if(!qtyInput)return;
      const min=Number(qtyInput.min||1),max=qtyInput.max?Number(qtyInput.max):Infinity;
      const safe=Math.min(max,Math.max(min,Number(value||min)));
      qtyInput.value=String(safe);
      if(qtyDisplay)qtyDisplay.textContent=String(safe);
    };
    root.querySelector('[data-wg-vape-minus]')?.addEventListener('click',()=>setQty(Number(qtyInput?.value||1)-1));
    root.querySelector('[data-wg-vape-plus]')?.addEventListener('click',()=>setQty(Number(qtyInput?.value||1)+1));
    setQty(qtyInput?.value||1);

    const upsell=root.querySelector('[data-wg-vape-upsell]');
    const upsellInput=root.querySelector('[data-wg-vape-upsell-input]');
    const CARBON_X_VARIANT_ID=42280613970093;
    const upsellVariantId=Number(upsell?.dataset.variantId||CARBON_X_VARIANT_ID);
    const syncUpsell=()=>upsell?.classList.toggle('is-checked',Boolean(upsellInput?.checked));
    upsellInput?.addEventListener('change',syncUpsell);
    syncUpsell();

    const setLoading=state=>{
      root.classList.toggle('wg-loading',state);
      [addButton,buyButton].forEach(btn=>{if(btn)btn.disabled=state||btn.getAttribute('aria-disabled')==='true';});
    };
    const addItems=async checkout=>{
      const variant=currentVariant();
      if(!variant||!variant.available||!form)return;
      setLoading(true);
      try{
        const err=root.querySelector('[data-wg-vape-error]');
        if(err){err.hidden=true;err.textContent='';}

        // Use the complete form payload used by the working Reformation template.
        // Appstle's selected selling_plan and app-added line properties stay intact.
        const formData=new FormData(form);
        formData.set('id',String(variant.id));
        formData.set('quantity',String(Math.max(1,Number(qtyInput?.value||1))));
        formData.delete('sections');
        formData.delete('sections_url');
        formData.append('sections','main-cart,cart-drawer,cart-bubble');
        formData.append('sections_url',window.location.pathname);

        let response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{
          method:'POST',
          headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:formData
        });
        let state=await response.json();
        if(!response.ok||state.status)throw new Error(state.description||'Unable to add this item to the cart.');

        if(upsellInput?.checked){
          if(!Number.isFinite(upsellVariantId)||upsellVariantId<=0)throw new Error('The Carbon-X add-on variant is not configured.');
          response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:[{id:upsellVariantId,quantity:1}],sections:['main-cart','cart-drawer','cart-bubble'],sections_url:window.location.pathname})
          });
          state=await response.json();
          if(!response.ok||state.status)throw new Error(state.description||'The add-on could not be added.');
        }

        renderCartSections(state);
        if(checkout)window.location.href=`${window.Shopify?.routes?.root||'/'}checkout`;
        else openCartDrawer();
      }catch(error){
        const err=root.querySelector('[data-wg-vape-error]');
        if(err){err.textContent=error.message||'Unable to add this item to the cart.';err.hidden=false;}
      }finally{setLoading(false);}
    };
    form?.addEventListener('submit',e=>{
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addItems(false);
    });
    buyButton?.addEventListener('click',e=>{e.preventDefault();addItems(true);});
    root.querySelectorAll('[data-wg-vape-scroll-buybox]').forEach(btn=>btn.addEventListener('click',e=>{
      e.preventDefault();root.querySelector('[data-wg-vape-buybox]')?.scrollIntoView({behavior:'smooth',block:'start'});
    }));

    root.querySelectorAll('video[data-src]').forEach(video=>{if(!video.src&&video.dataset.src)video.src=video.dataset.src;});
    if(window.lucide?.createIcons)window.lucide.createIcons({attrs:{'stroke-width':1.8}});
    updateVariant();
  };

  const initAll=(scope=document)=>{
    if(scope.matches?.('[data-wg-vape-section]'))init(scope);
    scope.querySelectorAll?.('[data-wg-vape-section]').forEach(init);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());else initAll();
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();
